import { PayloadAction } from '@reduxjs/toolkit';
import { DesignError, DesignState } from 'src/store/design/types';

const removeDesignErrorReducer = (state: DesignState, action: PayloadAction<DesignError>) => {
  state.errors = state.errors.filter((error) => error !== action.payload);
};

export default removeDesignErrorReducer;
